import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueSession from 'vue-session';
import vuetify from './plugins/vuetify';
import axios from './plugins/axios';
import VueAxios from 'vue-axios';
import Toasted from 'vue-toasted';
import CKEditor from 'ckeditor4-vue';
import { serialize } from 'object-to-formdata';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

Vue.config.productionTip = false;

Vue.use(VueSession, {
    persist: true,
});
Vue.use(VueAxios, axios);
Vue.use(Toasted, {
    iconPack: 'mdi',
    position: 'bottom-right',
    duration: 5000,
});

Vue.use(CKEditor);

moment.locale('es');
moment.tz.setDefault('America/Lima');
Vue.use(VueMoment, {
    moment,
});

Vue.mixin({
    methods: {
        serialize,
        assetAWS: (url = null) => {
            return process.env.VUE_APP_AWS_URL + url;
        },
        apiUrl: (url = null) => {
            return process.env.VUE_APP_URL_API + url;
        },
        validarPermiso(valor) {
            let sessionPermisos = this.$session.get('jsPermissions');

            if (
                sessionPermisos != 0 &&
                sessionPermisos != null &&
                sessionPermisos != '0' &&
                sessionPermisos != undefined
            ) {
                let permisosRoles = JSON.parse(sessionPermisos);
                let permisos = permisosRoles.permissions;
                let roles = permisosRoles.roles;
                return permisos.includes(valor);
            }
        },

        formatCode(number, length = 7) {
            return String(number).padStart(length, '0');
        },

        reduceText(text, length = 100) {
            if (!text) {
                return '';
            }

            if (text?.length <= length) {
                return text;
            }

            return text?.substring(0, length) + '...';
        },

        handleErrorApi(error) {
            if(error.response === undefined){
                console.error('Error:', error);
                return;
            }

            const response = error.response;
            const {status} = response;

            if(status === 422){
                const errors = response.data.errors;
                let message = [];
                for(const key in errors){
                    errors[key].forEach(msg => {
                        message.push(msg);
                    });
                }

                this.$toasted.error(message.join(' '));
                return;
            }

            if (status === 400) {
                this.$toasted.error(response.data.message || 'Error de servidor. Por favor, inténtalo de nuevo más tarde.');
                return;
            }

            this.$toasted.error('Error de servidor. Por favor, inténtalo de nuevo más tarde.');
        }
    },
});

new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
